<div class="modal fade">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
        <img src="././assets/icon/backArrow.svg" class="cp">
        <label class="font_semibold fs-18 ml-10 mt-5 black_color">
          <span class="cp">Learning & Development
          </span> /
          <span [style.color]="buttonColorName">Setup</span>
        </label>
      </div>
      <div class="modal-body p-20">
        <div class="mt-10">

          <div class="">

            <ion-row>
              <ion-col size="3" style="padding-left: 10px;" class="form-col">
               
                <mat-form-field class="custom-mat-field mat-height40 mat-input-style">
                  <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                    (selectionChange)="selectYearSetup(selectedYearForCompetency)">
                    <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                      {{sharedService.transformYearToFyFormat(item.year)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ion-col>
            </ion-row>


            <!---========================KPI Cap Value ============================---> 
            
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="4" size-md="12" size-lg="12" size-xs="12">
                  <div class="font_bold fs-14">Cap Value</div>
                  </ion-col>                  
                </ion-row>
              </div>
              <div class="p-10 commonp">

                <div style="padding: 0px 8px 8px 8px;">
                  <ion-row>
                    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                    <div class="commnf">Cap on KPI % Achievement</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" 
                              [disabled]="!editFlagForKpi"
                              style="color: black !important;"
                              [(ngModel)]="kpiCapValue"
                              placeholder="Type here"
                              class="font_regular"
                              min="0"
                              (keypress)="preventNegative($event)">

                      </mat-form-field>
                    </ion-col>
                    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="editm">
                    
                      <div class="d-flex ">
                        
                        <img (click)="onClickEditForKpi()" *ngIf="kpiCapId !== null && !editFlagForKpi"
                          class="ml-5 cp imgEdit" title="Edit" src="./assets/icon/edit.png" />
                       
                        <span (click)="onClickCloseForKpi()" *ngIf="editFlagForKpi"
                          class="material-icons close p-10 cp fs-20">close</span>
                       
                        <span *ngIf="editFlagForKpi" (click)="saveForKpi()"
                        
                          class="material-icons link p-10 cp fs-20">check</span>
                      </div>
                    </ion-col>

                  <!-- ================== cap on Competency  actual ===================== -->
                    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-10">
                      <div class="commnf">Cap on Competency Actual</div>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput 
                              type="number"
                              [disabled]="!editFlagForCapActual"
                              style="color: black !important;"
                              [(ngModel)]="competencyCapValue"
                              placeholder="Type here"
                              class="font_regular"
                              min="0"
                              (keypress)="preventNegative($event)">
                      </mat-form-field>
                    </ion-col>
                    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="mt-20 editm" >
                    
                      <div class="d-flex">
                        <img (click)="onClickEditForCapActual()" *ngIf="capActaulId !== null && !editFlagForCapActual"
                          class="ml-5 cp imgEdit" title="Edit" src="./assets/icon/edit.png" />
                       
                        <span (click)="onClickCloseForCapActual()" *ngIf="editFlagForCapActual"
                          class="material-icons close p-10 cp fs-20">close</span>
                       
                        <span *ngIf="editFlagForCapActual" (click)="saveForCapActual()"
                          class="material-icons link p-10 cp fs-20">check</span>
                      </div>
                    </ion-col>
                  </ion-row>
                </div>
              </div>
            </div>

            <!-- ========================== Add Rating Scale ===== -->

            <div class="cardBox mb-20 mt-2">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14"> Rating Scale</div>
                  </ion-col>
                </ion-row>
              </div>
           
              <div class="pl-10 commonp" >

                <ion-row class="p-0">
                  <ion-col size="6">
                    <ion-row class="ml-2">
                      <ion-col size="12" >
                        <div class="font_semibold addnewbtn fs-14 cp"
                          (click)="toggleInputs('addRatingScale')">
                          <!-- + Add New -->
                          {{ ratingScale ? "" : "+ Add Rating Scale" }}
                        </div>
                      </ion-col>
                      
                      <ion-row *ngIf="ratingScale" class="mb-15">
                        <ion-col size="6">
                          <mat-form-field class="w-100 mat-height40 mat-input-style">
                            <input matInput [(ngModel)]="rating" type="number" placeholder="Rating"
                              class="font_regular fs-12" />
                          </mat-form-field>
                        </ion-col>
                        <ion-col size="6">
                          
                          <ion-col size="12">
                            <mat-form-field class="w-100 mat-height40 mat-input-style">
                              <input matInput [(ngModel)]="definition" type="text" placeholder="Definition"
                                class="font_regular fs-12" />
                            </mat-form-field>
                          </ion-col>
                          
                       
                        </ion-col>
                        <ion-col size="12" *ngIf="ratingScale">
                          <ion-row>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn fs-14 cp" (click)="saveRatingScale()">
                                Save
                              </div>
                            </ion-col>
                            <ion-col size="auto">
                              <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="removeInputs()">
                                Remove
                              </div>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                    </ion-row>
                    <div class="table-container">
                      <table class="hover mb-5 custom-table">
                        <thead>
                          <tr>
                            <th class="fs-14 font_bold cl-black">Rating</th>
                            <th class="fs-14 font_bold cl-black">Defination</th>
                            <th *ngIf="getratingScale.length > 0" ><ion-icon name="trash-outline" style="padding-top: 0px;" class="cp red-cl  fs-18"
                              (click)="deleteRatings('addRatingScale')"></ion-icon></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of getratingScale">
                            <td class="fs-14 font_regular">{{ item.rating }}</td>
                            <td class="fs-14 font_regular">{{ item.definition }}</td>
                            <td ></td>
                          </tr>
                        </tbody>
                      </table>
                     
                    </div>
                  </ion-col>

                </ion-row>

              </div>
            </div>

            <!-- ========================================== Nominate Employees =======================================-->
            
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Who Will Nominate Employees ?</div>
                  </ion-col>
                </ion-row>
              </div>
              <div class="pl-10 commonp">
                <ion-row>
                  <mat-radio-group  aria-label="Select Status" class="fs-14 font_semibold">
                    <mat-radio-button value="Approved" >
                      Manager
                    </mat-radio-button>
                    <mat-radio-button value="Rejected" class=" pl-10">
                      HOD
                    </mat-radio-button>
                  </mat-radio-group>
                  
                </ion-row>


              </div>
            </div>


            <!-- ====================== Training Reaction feedback form-Employee ======================================  -->

              <div class="cardBox mb-20">
                <div class="cardBoxHeading font_medium fs-14">
                  <ion-row class="pl-5">
                    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                      <div class="font_bold fs-14">Training Reaction Feedback Form - Employee</div>
                    </ion-col>
                  </ion-row>
                </div>

                <div style="padding: 20px;">
                  <table class="custom-table mat-elevation-z1 tableFourth" style="width: 100%; table-layout: fixed;">
                    <tr class="mainHeading">
                      <th style="width: 15%;">Question Type</th>
                      <th style="width: 70%;">Questions</th>
                      <th style="width: 15%;">
                        <div class="font_semibold addnewbtn fs-14 cp" (click)="addRow()">+ Add</div>
                      </th>
                    </tr>

                    <tr *ngFor="let row of employeeFeedbackList; let i = index">
                      <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <mat-select placeholder="Select" [(ngModel)]="row.questionType" [disabled]="editedScoreId !== i">
                            <mat-option *ngFor="let option of addQuestionForEmployee" [value]="option.questionType">
                              {{ option.questionType }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>

                      <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <textarea matInput [(ngModel)]="row.question" placeholder="Type question..."
                            class="font_regular fs-12" [disabled]="editedScoreId !== i"></textarea>
                        </mat-form-field>
                      </td>

                      <td class="text-center">
                        <ng-container *ngIf="editedScoreId === i; else editBtn">
                          <span class="material-icons cp fs-20 green" (click)="saveEmployeeFeedback(row)">check</span>
                          <span class="material-icons cp fs-20 red" (click)="cancelEdit()">close</span>
                        </ng-container>
                        <ng-template #editBtn>
                          <span class="material-icons cp fs-20 blue" (click)="editRow(i)">edit</span>
                          <span class="material-icons cp fs-20 red" (click)="deleteFeedback(row)">delete</span>
                        </ng-template>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>


            <!-- =================================== Training Job learning Feedback Form - Manager =========================================================== -->
            <div class="cardBox mb-20">
              <div class="cardBoxHeading font_medium fs-14 commonp">
                <ion-row class="pl-5">
                  <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                    <div class="font_bold fs-14">Training Job learning Feedback Form - Manager</div>
                  </ion-col>
                </ion-row>
              </div>
          
              <div style="padding: 20px;">
                <table class="custom-table mat-elevation-z1 tableFourth" style="width: 100%; table-layout: fixed;">
                  <tr class="mainHeading">
                    <th style="width: 15%;">Question Type</th>
                    <th style="width: 70%;">Questions</th>
                    <th style="width: 15%;">
                      <div class="font_semibold addnewbtn fs-14 cp" (click)="addRowForLearning()">+ Add</div>
                    </th>
                  </tr>
          
                  <tr *ngFor="let row of employeeFeedbackListForLearning; let i = index">
                    <td>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <mat-select placeholder="Select" [(ngModel)]="row.questionType" [disabled]="editedScoreIdForlearning !== i">
                          <mat-option *ngFor="let option of addQuestionForManagerJobLearning" [value]="option.questionType">
                            {{ option.questionType }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
          
                    <td>
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <textarea matInput [(ngModel)]="row.question" placeholder="Type question..."
                          class="font_regular fs-12" [disabled]="editedScoreIdForlearning !== i"></textarea>
                      </mat-form-field>
                    </td>
          
                    <td class="text-center">
                      <ng-container *ngIf="editedScoreIdForlearning === i; else editBtn">
                        <span class="material-icons cp fs-20 green" (click)="saveJobLearningFeedback(row)">check</span>
                        <span class="material-icons cp fs-20 red" (click)="cancelEditForLearning()">close</span>
                      </ng-container>
                      <ng-template #editBtn>
                        <span class="material-icons cp fs-20 blue" (click)="editRowfForLearning(i)">edit</span>
                        
                        <span class="material-icons cp fs-20 red" (click)="deleteLearningFeedback(row)">delete</span>
                      </ng-template>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          

     <!-- Training Job Behavior Feedback Form - Manager -->
     <div class="cardBox mb-20">
      <div class="cardBoxHeading font_medium fs-14">
        <ion-row class="pl-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="font_bold fs-14">Training Job Behavior Feedback Form - Manager</div>
          </ion-col>
        </ion-row>
      </div>
  
      <div style="padding: 20px;">
        <table class="custom-table mat-elevation-z1 tableFourth" style="width: 100%; table-layout: fixed;">
          <tr class="mainHeading">
            <th style="width: 15%;">Question Type</th>
            <th style="width: 70%;">Questions</th>
            <th style="width: 15%;">
              <div class="font_semibold addnewbtn fs-14 cp" (click)="addRowForBehaviour()">+ Add</div>
            </th>
          </tr>
  
          <tr *ngFor="let row of employeeFeedbackListForBehaviour; let i = index">
            <td>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="row.questionType" [disabled]="editedScoreIdForBehaviour !== i">
                  <mat-option *ngFor="let option of addQuestionForManagerJobLearning" [value]="option.questionType">
                    {{ option.questionType }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
  
            <td>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <textarea matInput [(ngModel)]="row.question" placeholder="Type question..."
                  class="font_regular fs-12" [disabled]="editedScoreIdForBehaviour !== i"></textarea>
              </mat-form-field>
            </td>
  
            <td class="text-center">
              <ng-container *ngIf="editedScoreIdForBehaviour === i; else editBtn">
                <span class="material-icons cp fs-20 green" (click)="saveJobBehaviorFeedback(row)">check</span>
                <span class="material-icons cp fs-20 red" (click)="cancelEditForBehaviour()">close</span>
              </ng-container>
              <ng-template #editBtn>
                <span class="material-icons cp fs-20 blue" (click)="editRowfForBehaviour(i)">edit</span>
                
                <span class="material-icons cp fs-20 red" (click)="deleteBehaviorFeedback(row)">delete</span>
              </ng-template>
            </td>
          </tr>
        </table>
      </div>
    </div>
  

          </div>
        </div>
      </div>
    </div>
  </div>
</div>